(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyber-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mp-announcement-bar')) {
    class MpAnnouncementBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.currentSlide = 0;
        this.rotationTimer = null;
        this.countdownTimer = null;

        if (this.wasDismissed()) {
          this.hidden = true;
          return;
        }

        this.showSlide(0);
        this.setupDismissal();
        this.setupCountdown();
        this.setupRotation();
      }

      disconnectedCallback() {
        window.clearInterval(this.rotationTimer);
        window.clearInterval(this.countdownTimer);
      }

      wasDismissed() {
        if (this.dataset.rememberDismissal !== 'true') return false;

        try {
          return window.sessionStorage.getItem(this.dataset.storageKey) === 'true';
        } catch (error) {
          return false;
        }
      }

      setupDismissal() {
        const closeButton = this.querySelector('[data-close]');
        if (!closeButton) return;

        closeButton.addEventListener('click', () => {
          if (this.dataset.rememberDismissal === 'true') {
            try {
              window.sessionStorage.setItem(this.dataset.storageKey, 'true');
            } catch (error) {
              this.hidden = true;
            }
          }

          this.hidden = true;
          window.clearInterval(this.rotationTimer);
          window.clearInterval(this.countdownTimer);
        });
      }

      setupRotation() {
        if (this.dataset.rotate !== 'true') return;
        if (this.slides.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const interval = Number.parseInt(this.dataset.interval, 10) || 5000;
        const start = () => {
          window.clearInterval(this.rotationTimer);
          this.rotationTimer = window.setInterval(() => {
            this.showSlide((this.currentSlide + 1) % this.slides.length);
          }, interval);
        };
        const stop = () => window.clearInterval(this.rotationTimer);

        start();

        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', stop);
          this.addEventListener('mouseleave', start);
          this.addEventListener('focusin', stop);
          this.addEventListener('focusout', start);
        }
      }

      showSlide(index) {
        this.currentSlide = index;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');

          slide.querySelectorAll('a, button').forEach((element) => {
            if (active) {
              element.removeAttribute('tabindex');
            } else {
              element.setAttribute('tabindex', '-1');
            }
          });
        });
      }

      setupCountdown() {
        if (this.dataset.timerEnabled !== 'true') return;

        const timer = this.querySelector('[data-timer]');
        const timerLabel = this.querySelector('[data-timer-label]');
        const timerValue = this.querySelector('[data-timer-value]');
        const endTime = Date.parse(this.dataset.timerEnd);

        if (!timer || !timerValue || Number.isNaN(endTime)) return;

        timer.hidden = false;

        const update = () => {
          const remaining = endTime - Date.now();

          if (remaining <= 0) {
            window.clearInterval(this.countdownTimer);

            if (this.dataset.hideExpired === 'true') {
              this.hidden = true;
              return;
            }

            if (timerLabel) timerLabel.hidden = true;
            timerValue.textContent = this.dataset.expiredText || '00:00:00';
            return;
          }

          const totalSeconds = Math.floor(remaining / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const time = [hours, minutes, seconds]
            .map((value) => String(value).padStart(2, '0'))
            .join(':');

          timerValue.textContent = days > 0 ? `${days}d ${time}` : time;
        };

        update();
        this.countdownTimer = window.setInterval(update, 1000);
      }
    }

    customElements.define('mp-announcement-bar', MpAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emmett-image-upload"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const imageInput = document.getElementById('image-upload');
    const preview = document.getElementById('preview');

    imageInput.addEventListener('change', function() {
        const file = this.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = function(e) {
                preview.src = e.target.result;
                preview.style.display = 'block';  // Display the image
            };
            reader.readAsDataURL(file);
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
